module.exports = __webpack_public_path__ + "static/img/15051826621.c1fce10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15051826621.jpg
// module id = Nb2R
// module chunks = 0